import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const configuracoes = () => {
  const auth = useAuth();

  async function get() {
    let retorno;
    try {
        const {data} = await http.get('/settings', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function update(dados) {
    try {
      await http.put('/settings', dados, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  return {get, update}
}
